/**
 * 特殊文字を HTML 文字に変換します。
 *
 * @param input
 */
const htmlEscape = (input) => {
  return input.replace(/&#38;/g, "&")
    .replace(/&#60;/g, "<")
    .replace(/&#62;/g, ">")
    .replace(/&#34;/g, "\"")
    .replace(/&#39;/g, "'");
};

export default {
  htmlEscape
};
